import React, { useEffect, useState } from "react";
import { VirsionCheck } from "../../Helpers/Common"; //
import { ImgIcons, SVGIcons } from "../../Helpers/Common";
import { SendContactUs, userprofile } from "../../Model/Users"; //Include Home
import Profilemenu from "../Profile_menu/Profilemenu";
import { Metadata } from "../Metadata/Metadata";
import BarLoader from "react-spinners/BarLoader";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import HeaderEth from "../common/HeaderEth";
import FooterEth from "../common/FooterEth";
var ImageData = "";
var SVGIcon = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

export default function ContactUs(props) {
  const [VirsionCheckData, setVirsionCheckData] = useState([]);
  const [VirsionCheckDataloaded, setVirsionCheckDataloaded] = useState(false);
  const [ProfileData, setProfileData] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      let data = {
        seesionID: localStorage.getItem("session_id"),
        userID: localStorage.getItem("userID")
      }
      const vcheckres = await VirsionCheck();
      const userDatares = await userprofile(data);
      if (userDatares.data.message === "session_expired") {
        setVirsionCheckData(vcheckres);
        setVirsionCheckDataloaded(true);
      } else {
        const userData = JSON.parse(userDatares.data.message);
        setVirsionCheckData(vcheckres);
        setVirsionCheckDataloaded(true);
        setProfileData(userData.user_data);
      }
    };

    fetchData();
  }, []);

  if (VirsionCheckDataloaded == false) {
    return <div className="loader"><BarLoader color="#ff000f" /></div>;
  } else {
    return (
      <>
        <Metadata page="TERMS" />
        <HeaderEth />
        <main className="TermsofUse">
          <div >
            <div className="homeBanner">
              <div className="innerBanner mb-0">
                <div className="policy-title">
                  <h1>Contact <span className="red"> US</span></h1>
                </div>
              </div>
            </div>
            <div className="temp37 contact-us">
              <div className="temp37-inn">
                <p>SMS: 8994</p>
                <p>Web: https://www.ethiotelecom.et/</p>
                <p>Email: 994@ethionet.et</p>
                <p>WhatsApp Chat: +251 99 400 0000</p>
                <p>Telegram: https://t.me/ethio_telecom</p>
              </div>
            </div>
          </div>
        </main>
        <FooterEth />
      </>
    );
  }
}
